import React from "react";
const SvgCercaCasaInfoNoRes = props => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="#FF8000"
      fillRule="evenodd"
      d="M8 15A7 7 0 108 1a7 7 0 000 14z"
      clipRule="evenodd"
    />
    <g fill="#fff">
      <path
        fillRule="evenodd"
        d="M8 7.5a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3A.75.75 0 018 7.5z"
        clipRule="evenodd"
      />
      <path d="M9.1 5.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0z" />
    </g>
  </svg>
);
export default SvgCercaCasaInfoNoRes;
